import { KeyboardEvent, MouseEvent, useCallback, useEffect, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"

import { AgGridReact } from "ag-grid-react"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"
import { WMS2060_R01Content } from "./Content_WMS2060_R01"
import { defaultWMS2060_R01Dto, WMS2060_R01Dto } from "./Dto_WMS2060_R01"
import { SearchSection_WMS2060_R01 } from "./SearchSection_WMS2060_R01"
import { useWMS2060_R01Store } from "./Store_WMS2060_R01"
import { WMS2060_R01Table } from "./Table_WMS2060_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_WMS2060_R01 = () => {
	

	const { 
		WMS2060_R01List,
		insertWMS2060_R01List,
		removeWMS2060_R01List,
		addDeletedWMS2060_R01List,
		allCount,
		initData 
	} = useWMS2060_R01Store();
	const { setMessage } = useUiuxStore();

	

	const gridRef = useRef<AgGridReact<WMS2060_R01Dto>>(null);

	// UserContent에서 필요한 핸들러 함수들을 가져옴
	const {
		defaultWMS2060_R01Row,
		fetchData,
		initContainerData,
		handleSaveClick,
		handleDeleteClick,
		handleExcelClick,
		handlePrintClick,
		buttonDisabled,
	} = WMS2060_R01Content({
		gridRef,
		setMessage,
		
	});

    const [clickable, setClickable] = useState(true);
	

	// 상단 '등록' 버튼 전용 핸들러
	const handleInsertClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
		InsertRowHandler({
			event: e,
			dataList: WMS2060_R01List,
			rowData: {...defaultWMS2060_R01Row(), valueIndex: -1},
			insertRow: insertWMS2060_R01List,
			defaultRowData: defaultWMS2060_R01Row(),
			setClickable
		});
	}, [WMS2060_R01List, insertWMS2060_R01List, setClickable, defaultWMS2060_R01Row]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onPrintClick={handlePrintClick}
			onInitClick={initContainerData}
		/>
		
		<SearchSection_WMS2060_R01 />
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				
				<WMS2060_R01Table 
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
				/>
			</div>
		</div>
		{/* 메시지 표시 컴포넌트 */}
		<Message />
	</div>
}